import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  CardContent,
  Divider,
  LinearProgress,
  Snackbar,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectUploadInProgress } from 'FRONTEND/reducers/upload';
import i18n from 'FRONTEND/utils/i18n';

dayjs.extend(relativeTime);

const SendingProgressBar = ({ id, progress, secondsRemaining }) => {
  const locale = useSelector((state) => state.user.locale);

  let formattedRemainingTime;
  if (['calculating', Infinity].includes(secondsRemaining)) {
    formattedRemainingTime = i18n._('calculating');
  } else if (progress === 100) {
    formattedRemainingTime = i18n._('done');
  } else {
    formattedRemainingTime = dayjs().locale(locale).add(secondsRemaining, 'seconds').fromNow();
  }
  return (
    <Box width='100%'>
      <Typography align='center'>#{id}: {`${Math.round(progress ?? 100)}%`} ({formattedRemainingTime})</Typography>
      <LinearProgress variant='determinate' value={progress || 0} className='sendingProgressSnackbar-progress' />
    </Box>
  );
};

const SendingProgressSnackbar = () => {
  const progressList = useSelector(selectUploadInProgress);

  const handleBeforeUnloadPrompt = (event) => {
    event.preventDefault();
    event.returnValue = 'unused string'; // Chrome requires returnValue to be set
  };

  useEffect(() => {
    if (progressList.length > 0) {
      window.addEventListener('beforeunload', handleBeforeUnloadPrompt);
    }
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnloadPrompt);
    };
  }, [progressList.length]);

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      open={progressList.length > 0}
    >
      <Card style={{ width: '300px' }}>
        {progressList.length > 1 ? (
          <Accordion square>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>{progressList.length} {i18n._('uploads in progress')}.</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box flexDirection='column' maxHeight='600px' width='100%'>
                {progressList.map(({ id, progress, secondsRemaining }, index) => (
                  <Box key={id} paddingY={5}>
                    <SendingProgressBar id={id} progress={progress} secondsRemaining={secondsRemaining} />
                    {index < progressList.length - 1 && (<Divider />)}
                  </Box>
                ))}
              </Box>
            </AccordionDetails>
          </Accordion>
        ) : (
          <CardContent>
            <SendingProgressBar id={progressList[0]?.id} progress={progressList[0]?.progress} secondsRemaining={progressList[0]?.secondsRemaining} />
          </CardContent>
        )}
      </Card>
    </Snackbar>
  );
};

export default SendingProgressSnackbar;
